import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import Tooltip from '@/components/mui/Tooltip';
import IconButton from '@mui/material/IconButton';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import MenuItem from '@/pages/company/WorkspaceRoute/components/DocumentContextMenu/components/MenuItem';

import { bindMenu, bindTrigger, usePopupState } from 'material-ui-popup-state/hooks';
import Menu from '@mui/material/Menu';

import ForwardToInboxOutlinedIcon from '@mui/icons-material/ForwardToInboxOutlined';
import InputIcon from '@mui/icons-material/Input';

const ThreeDotsButton = ({ linkID, onOpenSendByEmailDialog, onMoveToCompany, showMoveToCompany }) => {
  const popupState = usePopupState({ variant: 'popover', popupId: 'OtherMenu' });

  const menuItems = useMemo(
    () => [
      {
        id: 'sendByEmailLinked',
        title: (
          <FormattedMessage id="document.show.actions.sendByEmailLinked" defaultMessage="Share bundle via email" />
        ),
        action: () => onOpenSendByEmailDialog(linkID),
        icon: <ForwardToInboxOutlinedIcon />,
      },
      {
        id: 'moveLinkedToCompany',
        title: <FormattedMessage id="contextMenu.moveLinkedToCompany" defaultMessage="Move bundle to company" />,
        action: () => onMoveToCompany(linkID),
        icon: <InputIcon />,
        disabled: linkID.includes('_locked') || !showMoveToCompany,
      },
    ],
    [linkID, onMoveToCompany, onOpenSendByEmailDialog, showMoveToCompany],
  );

  return (
    <>
      <Tooltip
        t={{
          id: 'tooltip.more',
          defaultMessage: 'More',
        }}
      >
        <IconButton color="primary" {...bindTrigger(popupState)}>
          <MoreHorizIcon color="primary" />
        </IconButton>
      </Tooltip>

      <Menu
        {...bindMenu(popupState)}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {menuItems.map((entry) => (
          <MenuItem
            key={entry.id}
            entry={entry}
            onClick={() => {
              popupState.close();
              entry.action();
            }}
          />
        ))}
      </Menu>
    </>
  );
};

export default ThreeDotsButton;
